export default __webpack_public_path__ + "static/media/hamburger-menu.4c2ba4d3.svg";